































import {Component, Mixins} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import PageContentTop from '@/components/board/common/PageTopContent.vue';
import PageFormBtn from '@/components/board/common/PageFormBtn.vue';
import NoticeServiceTable from '@/components/board/notice/NoticeServiceTable.vue';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import PageFormDate from '@/components/board/common/PageFormDate.vue';
import PageContentBottom from '@/components/board/common/PageBottomContent.vue';
import PageDateRangePicker from '@/components/board/common/PageDateRangePicker.vue';
import PageDateFilterBtns from '@/components/board/common/PageDateFilterBtns.vue';

import {GridProps, GridFormatterData} from '@/types';
import {ManageNoticeCategory, ManageSearchType} from 'supporter';
import BoardMixin from '@/components/board/mixins/BoardMixin';
import {escapeHtml, centerWinOptions} from '@/utils/commonUtils';
import {momentAdd} from '@/utils/dateUtils';

@Component({
  components: {
    PageTitle,
    PageContentTop,
    NoticeServiceTable,
    PageFormBtn,
    PageFormSelect,
    PageDateRangePicker,
    PageDateFilterBtns,
    PageFormDate,
    PageContentBottom
  }
})
export default class NoticeService extends Mixins(BoardMixin) {
  private gridProps: GridProps = {
    columns: [
      {
        header: this.toI18n('BOARD_FAQ_POST_NUMBER'), // 게시글 번호
        name: 'noticeNo',
        align: 'center',
        minWidth: 25
      },
      {
        header: this.toI18n('BOARD_NOTICE_SERVICE_NOTICE_CATEGORY'), // 공지사항 카테고리
        name: 'noticeCategory',
        align: 'left',
        minWidth: 50,
        formatter: (data: GridFormatterData) => {
          return this.getNoticeCategory(data.value);
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: this.toI18n('BOARD_FAQ_TITLE'), // 제목
        name: 'noticeTitle',
        align: 'left',
        minWidth: 800,
        formatter: function(data) {
          const url = '/board/popup/notice/' + data.row.noticeNo + '?noticeTarget=' + data.row.noticeTarget;
          return `<a href="javascript:onClick=window.open ('${url}','noticeServiceWin','${centerWinOptions(1000, 800)}')">${escapeHtml(data.value)}</a>`;
        }
      },
      {
        header: this.toI18n('BOARD_FAQ_CREATION_DATE'), // 작성일시
        name: 'createdDateTime',
        align: 'center',
        minWidth: 120
      }
    ],
    pageOptions: {
      perPage: 30,
      page: 1,
      totalCount: 1
    }
  };

  private noticeQueryParameters: any = {
    params: {
      noticeCategory: '' as ManageNoticeCategory,
      searchType: '' as ManageSearchType,
      keyword: '',
      startDateTime: '',
      endDateTime: '',
      pageSize: 30,
      page: 1,
      noticeTarget: 'PLATFORM_TO_SERVICE'
    }
  };

  private search(page: number = 1): void {
    Object.assign(this.noticeQueryParameters.params, {
      page,
      startDateTime: this.dateReceiveData.startYmd + ' 00:00:00',
      endDateTime: this.dateReceiveData.endYmd + ' 23:59:59'
    });
    if (this.isSearchFormPassed()) {
      this.$api
        .getNoticePublic(this.noticeQueryParameters)
        .then((respones: any) => {
          const data = respones.data;
          this.gridProps.pageOptions.page = page;
          this.gridProps.pageOptions.totalCount = data.totalCount;
          this.searchResult.content = data.contents;
        })
        .catch(this.exceptionHandler);
    }
  }
  private reset(): void {
    Object.assign(this.noticeQueryParameters.params, {
      noticeCategory: this.noticeCategoryData[0].value as ManageNoticeCategory,
      searchType: this.searchTypeData[0].value as ManageSearchType,
      keyword: '',
      pageSize: 30,
      page: 1
    });
    this.dateFilterChange(3);
    Object.assign(this.dateData, {
      startYmd: momentAdd(this.today, this.filterDateMapping[this.currentDateRange], 'YYYY-MM-DD'),
      endYmd: this.today
    });
  }

  private isSearchFormPassed() {
    if (this.noticeQueryParameters.params.searchType !== 'ALL' && (this.noticeQueryParameters.params.keyword === '' || this.noticeQueryParameters.params.keyword === undefined)) {
      alert(window.$t('BOARD_MIXINS_PLEASE_INPUT'));
      return false;
    }
    return true;
  }

  private created(): void {
    this.reset();
    this.search();
  }
}
